module.exports = __webpack_public_path__ + "img/eq-scythe.c7c06e1f.png";